import React, { useState } from 'react';

export interface AppMoneyInputProps {
  value: number;
  onChange: (value: number) => void;
  className?: string;
  colorBySign?: boolean;
}

const AppMoneyInput: React.FunctionComponent<AppMoneyInputProps> = ({ value, onChange, className, colorBySign }) => {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState('');

  const display = focused ? draft : (Number(value) || 0).toFixed(2);

  const colorClass = colorBySign
    ? ((Number(value) || 0) < 0 ? 'text-danger' : 'text-success')
    : '';

  return (
    <input
      type="text"
      inputMode="decimal"
      className={`${className ?? ''} ${colorClass}`}
      value={display}
      onFocus={() => {
        setFocused(true);
        setDraft(String(Number(value) || 0));
      }}
      onChange={(e) => {
        const raw = e.target.value.replace(',', '.');
        setDraft(raw);
        const parsed = parseFloat(raw);
        if (!isNaN(parsed)) onChange(parsed);
        else if (raw === '' || raw === '-') onChange(0);
      }}
      onBlur={() => {
        setFocused(false);
        const parsed = parseFloat(draft.replace(',', '.'));
        onChange(isNaN(parsed) ? 0 : parsed);
      }}
    />
  );
};

export default AppMoneyInput;
